import { defineStore } from 'pinia';
import { ref } from 'vue';

import { getUserInfo } from '@/api/user';
import { getCookie } from '@/fe_modules/utils/cookie';
import { currEvn } from '@/utils/http_help';

interface UserInfo {
  auditStatus: string;
  userType: string; // FT全职
}

export const useUserStore = defineStore('user', {
  state() {
    const initCookie = () => {
      const trId =
        decodeURI(getCookie(`woordee_${currEvn}_talent_login_user`))
          .split('|')
          .reverse()[0] || '';
      return trId;
    };

    return {
      trId: ref(initCookie()),
      userInfo: ref(null as UserInfo | null)
    };
  },
  getters: {},
  actions: {
    getUserInfo() {
      return new Promise((resolve, reject) => {
        if (!this.trId) {
          return;
        }
        getUserInfo({
          trId: this.trId
        })
          .then((res) => {
            this.userInfo = res.data;
            resolve(this.userInfo);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  }
});
